module.exports = __webpack_public_path__ + "static/media/notify.6b55727f.mp3";